import { Media, createMedia } from './media'
import { ItemList, createItemList } from './itemList'
import { Author } from './author'
import { ContentSection, mapContentSections } from './contentSection'
import { RelatedArticle } from './relatedArticle'

export interface Content {
  id: string
  handle: string
  locale: string
  globalHandle: string
  cmsSyncSource: string
  cmsSyncSourceDomain: string
  cmsSyncSourceContentId?: string
  type: string
  title?: string
  description?: string
  sections?: ContentSection[]
  tags?: Array<string>
  fields?: object
  articleLists?: Array<ItemList>
  relatedArticles?: Array<RelatedArticle>
  collectionHandle?: string
  content?: string
  contentHtml?: string
  excerpt?: string
  blogHandle?: string
  featuredMedia?: Media
  author?: Author
  publishDate?: number
  createdAt?: number
  updatedAt?: number
  indexedAt: number
}

export interface CreateContentOptions {
  id?: string
  handle?: string
  locale?: string
  globalHandle?: string
  cmsSyncSource?: string
  cmsSyncSourceDomain?: string
  cmsSyncSourceContentId?: string
  type?: string
  title?: string
  description?: string
  sections?: string | ContentSection[]
  tags?: Array<string>
  fields?: object
  articleLists?: Array<ItemList> | null
  relatedArticles?: Array<RelatedArticle>
  collectionHandle?: string
  content?: string
  contentHtml?: string
  excerpt?: string
  blogHandle?: string
  featuredMedia?: Media | null
  author?: Author
  publishDate?: number
  createdAt?: number
  updatedAt?: number
  indexedAt?: number
}

export const createContent = (obj: CreateContentOptions): Content => {
  const { articleLists, featuredMedia, sections, ...rest } = obj
  const content = {
    id: '',
    handle: '',
    locale: '',
    globalHandle: '',
    cmsSyncSource: '',
    cmsSyncSourceDomain: '',
    cmsSyncSourceContentId: '',
    type: 'content',
    indexedAt: 0,
    articleLists: null as null | ItemList[],
    featuredMedia: null as null | Media,
    relatedArticles: [],
    ...rest
  } as Content

  if (sections) {
    content.sections = mapContentSections(sections, content.cmsSyncSource)
  }

  if (articleLists && Array.isArray(articleLists)) {
    content.articleLists = articleLists.map((list: ItemList) => {
      return createItemList(list)
    })
  }

  if (featuredMedia) {
    content.featuredMedia = createMedia(featuredMedia)
  }

  return content
}
